/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_Vs_PhInputs */

const en_directory_footer_link_vs_ph = /** @type {(inputs: Directory_Footer_Link_Vs_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs Product Hunt`)
};

const zh_directory_footer_link_vs_ph = /** @type {(inputs: Directory_Footer_Link_Vs_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比 Product Hunt`)
};

/**
* | output |
* | --- |
* | "vs Product Hunt" |
*
* @param {Directory_Footer_Link_Vs_PhInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_vs_ph = /** @type {((inputs?: Directory_Footer_Link_Vs_PhInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_Vs_PhInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_vs_ph(inputs)
	return zh_directory_footer_link_vs_ph(inputs)
});
export { directory_footer_link_vs_ph as "directory.footer.link_vs_ph" }